// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ec9aeae3","491":"ebad1e5a","648":"7c54adf8","712":"0dc3da08","733":"8b9fcbf7","869":"167a12f4","904":"ae733a54"}[chunkId] + ".chunk.js";
};